import { createApp } from 'vue'
import { tooltipDirective } from './directives/tooltip';
import { createPinia } from 'pinia'

import axios from 'axios';
window.axios = axios;

const axiosInstance = axios.create({
    baseURL: "" // import.meta.env.VITE_SOME_NAME
})

import router from './router'

import App from './App.vue'

import moshaToast from 'mosha-vue-toastify'
import MasonryWall from '@yeger/vue-masonry-wall'

import Datepicker from '@vuepic/vue-datepicker';

import 'virtual:uno.css';

const app = createApp({})
const pinia = createPinia()

// On enregistre la directive sous le nom "tooltip"
app.config.globalProperties.$axios = axios;
app.config.globalProperties.axios = { ...axiosInstance }
app.use(pinia)
app.use(router)
app.use(moshaToast)
app.use(MasonryWall)
app.directive('tooltip', tooltipDirective)
app.component('App', App)
app.component('Datepicker', Datepicker)
app.mount('#app')
